var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.182,
    height: 17.897,
    viewBox: "0 0 18.182 17.897",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2475",
    "data-name": "Group 2475",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2300",
    "data-name": "Group 2300",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1811",
    "data-name": "Group 1811",
    transform: "translate(0 1.426)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_279",
    "data-name": "Rectangle 279",
    width: 4.406,
    height: 15.471,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5182",
    "data-name": "Path 5182",
    d: "M199.54,980.47a.77.77,0,1,0-.77.77A.767.767,0,0,0,199.54,980.47Z",
    transform: "translate(-196.574 -978.146)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1449",
    "data-name": "Line 1449",
    x2: 2.681,
    transform: "translate(0.87 10.209)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1450",
    "data-name": "Line 1450",
    x2: 2.681,
    transform: "translate(0.87 11.692)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1810",
    "data-name": "Group 1810",
    transform: "translate(1.483 12.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5183",
    "data-name": "Path 5183",
    d: "M199.355,1058.969h-.471l-.1.413H198.4l.528-1.882h.371l.528,1.882h-.385Zm-.4-.285h.314l-.157-.6H199.1Z",
    transform: "translate(-198.4 -1057.5)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1813",
    "data-name": "Group 1813",
    transform: "translate(6.388 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_280",
    "data-name": "Rectangle 280",
    width: 4.406,
    height: 15.471,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5184",
    "data-name": "Path 5184",
    d: "M244.34,970.47a.77.77,0,1,0-.77.77A.767.767,0,0,0,244.34,970.47Z",
    transform: "translate(-241.374 -968.146)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1451",
    "data-name": "Line 1451",
    x2: 2.681,
    transform: "translate(0.87 10.209)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1452",
    "data-name": "Line 1452",
    x2: 2.681,
    transform: "translate(0.87 11.692)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1812",
    "data-name": "Group 1812",
    transform: "translate(1.583 12.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5185",
    "data-name": "Path 5185",
    d: "M243.9,1049.382V1047.5h.542a.723.723,0,0,1,.456.128.451.451,0,0,1,.171.385.469.469,0,0,1-.057.242.454.454,0,0,1-.171.157.337.337,0,0,1,.228.157.456.456,0,0,1,.071.271.548.548,0,0,1-.157.414.684.684,0,0,1-.442.142H243.9Zm.371-1.084h.185a.271.271,0,0,0,.185-.071.242.242,0,0,0,.057-.185.282.282,0,0,0-.071-.2.278.278,0,0,0-.2-.057h-.171v.513Zm0,.257v.556h.271a.246.246,0,0,0,.185-.071.279.279,0,0,0,.057-.2.344.344,0,0,0-.057-.214.235.235,0,0,0-.171-.071h-.285Z",
    transform: "translate(-243.9 -1047.5)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1815",
    "data-name": "Group 1815",
    transform: "translate(12.776 1.426)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_281",
    "data-name": "Rectangle 281",
    width: 4.406,
    height: 15.471,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_260",
    "data-name": "Ellipse 260",
    cx: 0.77,
    cy: 0.77,
    rx: 0.77,
    ry: 0.77,
    transform: "translate(1.44 1.554)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1453",
    "data-name": "Line 1453",
    x2: 2.666,
    transform: "translate(0.87 10.209)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1454",
    "data-name": "Line 1454",
    x2: 2.666,
    transform: "translate(0.87 11.692)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1814",
    "data-name": "Group 1814",
    transform: "translate(1.554 12.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5186",
    "data-name": "Path 5186",
    d: "M289.783,1058.54h0a.556.556,0,0,1-.157.456.63.63,0,0,1-.456.157.645.645,0,0,1-.485-.185.7.7,0,0,1-.185-.513v-.556a.744.744,0,0,1,.171-.513.644.644,0,0,1,.471-.185.668.668,0,0,1,.471.157.576.576,0,0,1,.157.456v.014h-.342a.429.429,0,0,0-.057-.257.3.3,0,0,0-.214-.071.216.216,0,0,0-.2.1.58.58,0,0,0-.071.3v.556a.51.51,0,0,0,.071.3.25.25,0,0,0,.228.1.282.282,0,0,0,.2-.072.377.377,0,0,0,.057-.257h.342Z",
    transform: "translate(-288.5 -1057.2)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default __webpack_public_path__ + "static/media/Server.48d93fe0d440cd635259f1acd31d4cf8.svg";
export { ForwardRef as ReactComponent };